import React from 'react';
import { Link } from 'react-router-dom';

const Overview = ({ clientId, workoutsCount }) => {

  return (
    <div className="overview">
      <Link to={`/clients/${clientId}/program-overview`}>
        <h5>Program Overview</h5>
        <span>{ `${workoutsCount} workouts` }</span>
        <i className="fas fa-chevron-right"></i>
      </Link>
    </div>
  );
}

export default Overview;
